import React, { useEffect, useState } from 'react';
import { useOffline } from './OfflineContext';
import { subscribeInstall, trackInstall } from './install';
import styles from './InstallBanner.module.css';

// Shown on phones until the app is installed (founder's call: no dismiss,
// no first-listen gate). Never shown inside the installed app.
const isPhone = () => typeof window !== 'undefined'
  && (window.innerWidth <= 768 || (navigator.maxTouchPoints > 1 && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)));

export default function InstallBanner() {
  const offline = useOffline();
  const [, force] = useState(0);
  const [shown, setShown] = useState(false);

  useEffect(() => subscribeInstall(() => force((n) => n + 1)), []);

  const visible = !offline.standalone && isPhone();

  useEffect(() => {
    if (visible && !shown) { setShown(true); trackInstall('pwa_install_banner_shown'); }
  }, [visible, shown]);

  if (!visible) return null;

  return (
    <div className={styles.banner} role="region" aria-label="Install BYOPDF">
      <img className={styles.icon} src="/icons/icon-192.png" alt="" width={40} height={40} />
      <div className={styles.text}>
        <strong>Download audiobooks to your phone</strong>
        <span>Add BYOPDF to your Home Screen to keep books for flights and no-signal listening. Two taps, no app store.</span>
      </div>
      <button className={styles.cta} onClick={() => offline.showInstallSheet('banner')}>Show me how</button>
    </div>
  );
}
